/**
 * Statsig configuration utilities.
 */

import { getStatsigClientKey as getRuntimeStatsigKey } from '@/config/env-config';

/**
 * Check if Statsig is configured (has client key).
 */
export function isStatsigConfigured(): boolean {
  return Boolean(getRuntimeStatsigKey());
}

/**
 * Get the Statsig client key.
 */
export function getStatsigClientKey(): string {
  return getRuntimeStatsigKey();
}
